import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, AbstractControl, Validators, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { IShift } from 'src/app/interfaces/country';
import { DataService } from 'src/app/services/data.service';
import { pageKey } from 'src/app/services/mapping.service';
import { statusObj, SHIFT_TYPES } from 'src/app/dummy/status';
import { List } from 'src/app/stores/administrator/list.store';
import { AuthService } from 'src/app/auth/auth.service';
import { AuthStore } from 'src/app/stores/auth/auth.store';

@Component({
  selector: 'app-add-shift',
  templateUrl: './add-shift.component.html',
  styleUrls: ['./add-shift.component.scss']
})
export class AddShiftComponent implements OnInit {
  @ViewChild("focus", { static: false }) inputRef: ElementRef;

  form: FormGroup;
  shiftType: AbstractControl;
  duration: AbstractControl;
  name: AbstractControl;
  description: AbstractControl;
  order: AbstractControl;

  SHIFTTYPES = SHIFT_TYPES
  constructor(
    public dialogRef: MatDialogRef<AddShiftComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public store: List,
    public ds: DataService,
        public auth: AuthStore,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      shiftType: [SHIFT_TYPES[0], Validators.required],
      name: [null, Validators.required],
      duration: [null, Validators.required],
      description: [null],
      order: [null, Validators.required]
    });
    this.shiftType = this.form.controls['shiftType'];
    this.duration = this.form.controls["duration"]
    this.name = this.form.controls['name'];
    this.description = this.form.controls['description'];
    this.order = this.form.controls["order"]
  }

  create(f: any, isNew: boolean) {
    if (this.form.valid) {
      this.form.disable()
      const { shiftType, duration, order, name, description } = f;
      const item: IShift = {
        key: this.ds.createId(),
        page_key: pageKey(),
        created_date: new Date(),
        created_by: this.ds.collection('users').doc(`${this.auth.user.uid}`).ref,
        isDeleted: false,
        name: name,
        description: description,
        status: statusObj.active,
        duration: duration,
        order: order,
        shiftType: shiftType
      }
      this.store.save(this.ds.shiftRef(), item, (success, res) => {
        if (success) {
          if (!isNew) {
            this.dialogRef.close();
          }
          this.snackBar.open('Shift has been created.', 'done', { duration: 3000 });
          this.form.reset();
          this.form.enable();
          this.form.patchValue({
            shiftType
          })
          this.inputRef.nativeElement.focus();
        } else {
          alert(res);
        }
      })
    }
  }
}
